import { useEffect, useState } from "react";

export default function BuildInfoPage() {
  const [buildInfo, setBuildInfo] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    fetch("/build-info.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Build info file not found");
        }
        return response.json();
      })
      .then((data) => {
        if (isMounted) {
          setBuildInfo(data);
        }
      })
      .catch(() => {
        if (isMounted) {
          setError("Unable to load build info");
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <main style={{ padding: "24px" }}>
      <h1>Build Info</h1>
      {error && <p>{error}</p>}
      {!error && !buildInfo && <p>Loading...</p>}
      {buildInfo && (
        <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
{JSON.stringify(buildInfo, null, 2)}
        </pre>
      )}
    </main>
  );
}
